import * as React from 'react'
import { ColorChangeHandler, CustomPicker } from 'react-color'
import { EditableInput, Hue, Saturation } from 'react-color/lib/components/common'
import Button from '@mui/material/Button'

import './ColorPicker.sass'

/* react-color types can resolve a second @types/react; cast for JSX. */
const SaturationC = Saturation as any
const HueC = Hue as any
const EditableInputC = EditableInput as any

export type ColorPickerProps = {
    cancelColorPicker: () => void
    hex?: string
    onChange: ColorChangeHandler
    rgb?: any
    updateColor: () => void
}

export type ColorPickerState = {}

type RGBColors = Record<string, string | undefined>

export type CustomSwatchStyles = {
    background?: string
}

class ColorPicker extends React.Component<ColorPickerProps, ColorPickerState> {
    handleRGBChange = (RGBColor: RGBColors) => {
        const { onChange, rgb } = this.props
        const RGBKey = Object.keys(RGBColor)[0] as string
        const RGBInputValue = parseInt(String(RGBColor[RGBKey] ?? '0'), 10)
        const isValidRGB = RGBInputValue >= 0 && RGBInputValue <= 255

        if (!isValidRGB) {
            return
        }

        const newColor = { ...rgb }
        newColor[RGBKey] = String(RGBInputValue)

        onChange(newColor)
    }

    render() {
        const { cancelColorPicker, hex, onChange, rgb, updateColor } = this.props

        const swatchStyles: CustomSwatchStyles = {
            background: hex,
        }

        return (
            <div className="color-picker">
                <div className="saturation-picker">
                    <SaturationC {...this.props} onChange={onChange} />
                </div>
                <div className="hue-picker">
                    <HueC {...this.props} onChange={onChange} />
                </div>
                <div className="hex-field">
                    <EditableInputC value={hex} onChange={onChange} />
                </div>
                <div className="rgb-fields">
                    <EditableInputC
                        label="r"
                        value={rgb.r}
                        onChange={(RGBColor: RGBColors) => {
                            this.handleRGBChange(RGBColor)
                        }}
                    />
                    <EditableInputC
                        label="g"
                        value={rgb.g}
                        onChange={(RGBColor: RGBColors) => {
                            this.handleRGBChange(RGBColor)
                        }}
                    />
                    <EditableInputC
                        label="b"
                        value={rgb.b}
                        onChange={(RGBColor: RGBColors) => {
                            this.handleRGBChange(RGBColor)
                        }}
                    />
                </div>
                <div className="picker-actions">
                    <Button color="primary" className="update" variant="outlined" onClick={updateColor}>
                        Update
                    </Button>
                    <Button className="cancel" variant="text" onClick={cancelColorPicker}>
                        Cancel
                    </Button>
                </div>
                <div style={swatchStyles} />
            </div>
        )
    }
}

export default CustomPicker(ColorPicker as any)
